<template>
    <div class="columns is-mobile is-centered has-background-primary p-2">
        <h1 class="title is-4 has-text-white">CLIENTI</h1>
    </div>
    
    <div class="columns is-mobile is-centered">
        <div class="column is-5 has-text-centered">
            <div class="control">
                <input class="input is-primary" type="text" v-model="testoRicerca" placeholder="Cerca..." @keyup.enter="bCerca(['codice', 'nome', 'cognome', 'note'])">
            </div>
        </div>
        <div class="column is-1 has-text-centered" v-if="props.bottoneAggiungiVisibile==true && schermoLargo">
            <a class="button is-primary is-outlined" title="Ricerca completa" @click="bCerca(['JSON'])">
                <span class="icon"><i class="fas fa-eye"></i></span>
            </a>
        </div>
        <div class="column is-2" v-if="props.bottoneAnnullaVisibile">
            <a class="button" @click="bSelezionaCliente(null)">
                Annulla
            </a>
        </div>
    </div>
    <div class="columns is-mobile is-centered" v-if="props.bottoneAggiungiVisibile==true && !schermoLargo">
        <div class="column is-1 has-text-centered">
            <a class="button is-primary is-outlined" title="Ricerca completa" @click="bCerca(['JSON'])">
                <span class="icon"><i class="fas fa-eye"></i></span>
            </a>
        </div>
        <div class="column is-1">
        </div>
        <div class="column is-1 has-text-centered">
            <button class="button is-primary is-outlined" @click="bSelezionaCliente(-1)">
                <span class="icon"><i class="fas fa-plus"></i></span>
            </button>
        </div>
    </div>

    <div class="blocco-scroll" v-if="!schermoLargo">
        <div class="box" v-for="(cl, index) in elencoClienti" :key="index">
            <button class="button is-small is-primary is-outlined" @click="bSelezionaCliente(leggiInfoDB(cl).id)" v-if="props.bottoneAggiungiVisibile==true">
                <span class="icon"><i class="fas fa-arrow-right-from-bracket"></i></span>
            </button>
            &nbsp; {{cl.codice==0?'':cl.codice}}
            <div> {{generaStringaCliente(leggiInfoDB(cl).id,null,'clienteCorta')}} </div>
        </div>
        <div>
            &nbsp;  &nbsp; &nbsp; &nbsp; {{stringaNumeroRecord}}
        </div>
        <div>&nbsp;</div>
    </div>

    <div class="blocco-scroll" v-if="schermoLargo">
        <table class="table is-striped mx-auto">
            <thead>
                <tr>
                    <th class="has-text-centered">
                        <button class="button is-small is-primary is-outlined" @click="bSelezionaCliente(-1)" v-if="props.bottoneAggiungiVisibile==true">
                            <span class="icon"><i class="fas fa-plus"></i></span>
                        </button>
                    </th>
                    <th class="has-text-centered" v-if="mostraInfoSviluppo"></th>
                    <th class="has-text-centered" v-if="mostraInfoSviluppo">Id</th>
                    <th class="has-text-centered">Codice</th>
                    <th>Nome</th>
                    <th>Cognome</th>
                    <th class="has-text-centered" title="Note">N</th>
                    </tr>
            </thead>
            <tbody>
                <tr v-for="(cl, index) in elencoClienti" :key="cl">
                    <td class="has-text-centered">
                        <button class="button is-small is-primary is-outlined" @click="bSelezionaCliente(leggiInfoDB(cl).id)">
                            <span class="icon"><i class="fas fa-arrow-right-from-bracket"></i></span>
                        </button>
                    </td>
                    <!-- <td class="has-text-centered" v-if="mostraInfoSviluppo">{{index + 1}}</td> -->
                    <td class="has-text-centered" v-if="mostraInfoSviluppo">{{index + 1}}</td>
                    <td class="has-text-centered" v-if="mostraInfoSviluppo">{{leggiInfoDB(cl).id}} {{ cl._info ? 'F' : 'C' }}</td>
                    <td class="has-text-right">{{cl.codice==0?'':cl.codice}}</td>
                    <td>{{cl.nome}}</td>
                    <td>{{cl.cognome}}</td>
                    <td class="has-text-centered">
                        <ComponenteIcona nome="Nota" :visibileSempre="false" :descrizione="cl.note" />
                    </td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <td class="has-text-centered" colspan="2">{{stringaNumeroRecord}}</td>
                    </tr>
            </tfoot>
        </table>
    </div>
</template>

<script setup>
    import ComponenteIcona from "./ComponenteIcona.vue";
    import { defineProps, defineEmits, computed, ref } from "vue";
    import { dbClienti, dbContatti, leggiInfoDB } from "@/code/gestioneDB";
    import { generaStringaCliente, mostraInfoSviluppo, schermoLargo, getValorePerOrdinamento } from "@/code/utilita";

    // PROPRIETA' ED EVENTI DEL COMPONENTE
    const props = defineProps({
        testoDaCercare: {
            type: String,
            default: null },
        campiDaCercare: {           
            type: Array,
            default:   () => {return ['codice', 'nome', 'cognome', 'note']}
        },
        bottoneAnnullaVisibile: {
            type: Boolean,
            default: false },
        bottoneAggiungiVisibile: {
            type: Boolean,
            default: false },
        campoRicercaVisibile: {
            type: Boolean,
            default: true }
    });
    const emit = defineEmits(['elementoSelezionato','statoInterfacciaCambiato']);

    // VARIABILI DEL COMPONENTE
    const testoRicerca = ref(props.testoDaCercare);
    const stringaNumeroRecord = ref("");
    const elencoClienti = computed(()=>{
        let tempElencoClienti = [];
        for(const cl in dbClienti.value){
            tempElencoClienti.push(dbClienti.value[cl]);
        }
        ordinaElencoClienti(tempElencoClienti);
        filtraElencoElementi(tempElencoClienti, props.testoDaCercare, props.campiDaCercare);
        return tempElencoClienti;
    });

    // FUNZIONI DEL COMPONENTE
    function bCerca(campi) {
        emit('statoInterfacciaCambiato', {testoRicercaClienti: testoRicerca.value, campiRicercaClienti: campi});
    }

    function bSelezionaCliente(idCl) {
        emit('elementoSelezionato', {
            tipo: 'cliente',
            idCliente: idCl
        });
    }

    function ordinaElencoClienti(elencoCl) {
        elencoCl.sort((a, b) => {
            const codA = Number(getValorePerOrdinamento(a, 'codice', false)) || 0;
            const codB = Number(getValorePerOrdinamento(b, 'codice', false)) || 0;

            if (codA === codB) return 0;
            if (codA === 0) return 1;  
            if (codB === 0) return -1; 

            return codB - codA;
        });

        return elencoCl;
    }

    function filtraElencoElementi(elencoEl, testo, campi) {
        const tempStringaNumeroRecord = elencoEl.length;
        let elencoTesti = [];
        if (testo) elencoTesti = testo.split('+');
        
        for (let j=0; j < elencoTesti.length; j++) {
            if ( (elencoTesti[j]) && (elencoTesti[j]!="") ) {
                for (let i=0; i < elencoEl.length; i++) {
                    const regexCerca = new RegExp(elencoTesti[j], 'i');
                    let temp = null;
                    let pos = -1;
                    
                    if ( campi[0] == 'JSON' ) {
                        temp = JSON.stringify(elencoEl[i]);
                        pos = temp.search(regexCerca);
                        
                        if (pos==-1) {
                            // Ricerca nei contatti dei lead
                            if (elencoEl[i].leads) {
                                for(const ld in elencoEl[i].leads){
                                    if (elencoEl[i].leads[ld].contatti){
                                        for(const ct of Object.keys(elencoEl[i].leads[ld].contatti)){
                                            // FIX: Controlliamo che il contatto esista effettivamente in RAM per non generare undefined
                                            if (dbContatti.value[ct]) {
                                                temp = JSON.stringify(dbContatti.value[ct]);
                                                pos = temp.search(regexCerca);
                                                if (pos!=-1) {
                                                    break;
                                                }
                                            }
                                        }
                                    }
                                    if (pos!=-1) {
                                        break;
                                    }
                                }
                            }
                            // Ricerca nei contatti dei lavori
                            if (elencoEl[i].lavori && pos==-1) {
                                for(const lv in elencoEl[i].lavori){
                                    if (elencoEl[i].lavori[lv].contatti){
                                        for(const ct of Object.keys(elencoEl[i].lavori[lv].contatti)){
                                            // FIX: Controlliamo che il contatto esista effettivamente in RAM
                                            if (dbContatti.value[ct]) {
                                                temp = JSON.stringify(dbContatti.value[ct]);
                                                pos = temp.search(regexCerca);
                                                if (pos!=-1) {
                                                    break;
                                                }
                                            }
                                        }
                                    }
                                    if (pos!=-1) {
                                        break;
                                    }
                                }
                            }
                        }
                    } else {
                        for (const cc in campi) {
                            if (pos == -1) {
                                temp = elencoEl[i][campi[cc]];
                                pos = String(temp).search(regexCerca);
                            }
                        }
                    }
                    if (pos == -1) {
                        elencoEl.splice(i,1);
                        i--;
                    }
                }
            }
        }
        if (elencoEl.length>30){
            elencoEl.splice(25,(elencoEl.length-25));
        }
        stringaNumeroRecord.value = elencoEl.length + " di " + tempStringaNumeroRecord;
    }
</script>